<div class="documents" [@detailExpand]="isExpanded ? 'expanded' : 'collapsed'">
    @if (documents.length === 0) {
        <p>Chargement...</p>
    }
    <div class="document document-header">
        <div class="document-icon"></div>
        <div class="document-date"><span class="header">Date</span></div>
        <div class="document-from"><span class="header">De</span></div>
        <div class="document-to"><span class="header">A</span></div>
        <div class="document-label"><span class="header">Intitulé</span></div>
    </div>
    @for (document of documents; track document.id) {
        <div class="document">
            @if (document.type === DocumentType.Email) {
                <div class="document-icon">
                    <mat-icon>email</mat-icon>
                </div>
            } @else if (document.type === DocumentType.Sms) {
                <div class="document-icon">
                    <mat-icon>sms</mat-icon>
                </div>
            } @else if (document.type === DocumentType.Fax) {
                <div class="document-icon">
                    <mat-icon>print</mat-icon>
                </div>
            } @else if (document.type === DocumentType.File) {
                <div class="document-icon">
                    <mat-icon>insert_drive_file</mat-icon>
                </div>
            } @else if (document.type === DocumentType.Tchat) {
                <div class="document-icon">
                    <mat-icon>question_answer</mat-icon>
                </div>
            }
            <div class="document-date">{{ document.creationDate | date: FRENCH_DATETIME_FORMAT }}</div>
            <div class="document-from" [title]="document.from | avmEmailAddresses">{{ document.from | avmEmailAddresses }}</div>
            <div class="document-to" [title]="document.to | avmEmailAddresses">{{ document.to | avmEmailAddresses }}</div>
            <div class="document-label" [title]="document.label">{{ document.label }}</div>
        </div>
    }
</div>
